"use client";
import { useTranslations } from "next-intl";
import { actionTypes } from "../types";
import { CatContextualMenu } from "blocks-nextjs/blocks-react/components/ContextualMenu";
import { CatButton } from "blocks-nextjs/blocks-react/components/Button";
import { CatIconMenuDots } from "blocks-nextjs/blocks-react/components/Icons/MenuDots";
import { CatList } from "blocks-nextjs/blocks-react/components/List";
import { CatListItem } from "blocks-nextjs/blocks-react/components/ListItem";
import { ContextualMenu, Portal } from "components/pcc-components";
import { ROOT_PORTALS } from "constants/targets";
import { MY_EQUIP_GA_EVENTS } from "../constants";
import styles from "./my-equipment-action-menu.module.scss";

export interface ContextMenuActionProp {
  isDesktop: boolean;
  showContextualMenu: boolean;
  actionItems: actionTypes[];
  handleClick: (event: React.MouseEvent) => void;
  handleOpenContextualMenu: () => void;
  setShowContextualMenu: (value: boolean) => void;
  equipmentName?: string;
}

const ContextMenuActionLayout = ({
  isDesktop,
  actionItems,
  showContextualMenu,
  setShowContextualMenu,
  handleClick,
  handleOpenContextualMenu,
  equipmentName
}: Readonly<ContextMenuActionProp>) => {
  const t = useTranslations();
  const equipmentLabel =`${equipmentName} more`;

  return (
    <>
      <CatContextualMenu onClick={handleClick} position="bottom-end">
        <CatButton
          hideText
          slot="trigger"
          variant="ghost"
          className={styles["kebab-button"]}
          data-testid="small-card-kebab-button"
          onClick={handleOpenContextualMenu}
        > 
          <CatIconMenuDots slot="after"  aria-label={equipmentLabel}/>
        </CatButton>
        {isDesktop && (
          <div className="px-1">
            <CatList>
              {actionItems.map((item) => {
                return (
                  item.isActionVisible && (
                    <CatListItem
                      key={item.id}
                      data-testid={`quick-link-${item.id}`}
                      onBlSelect={() => item?.onClick()}
                      className={item.classNames}
                      data-track-event={MY_EQUIP_GA_EVENTS.PRIMARY_CTA}
                      data-track-attr-nltext={item.gaLabel}
                      data-track-attr-context={item.gaContext}
                    >
                      {t(item.label)}
                    </CatListItem>
                  )
                );
              })}
            </CatList>
          </div>
        )}
      </CatContextualMenu>
      {showContextualMenu && !isDesktop && (
        <Portal id={ROOT_PORTALS}>
          <ContextualMenu
            title={t("EQUIPMENT_OPTIONS")}
            titleVariant="title"
            setShowContextualMenu={setShowContextualMenu}
            showContextualMenu={showContextualMenu}
          >
            <CatList spacing="padded">
              {actionItems?.map((item) => {
                return (
                  item.isActionVisible && (
                    <CatListItem
                      key={item?.id}
                      data-testid={`quick-link-${item.id}`}
                      onBlSelect={() => {
                        item?.onClick();
                        setShowContextualMenu(false);
                      }}
                      className={item?.classNames}
                      status={item?.status}
                      data-track-event={MY_EQUIP_GA_EVENTS.PRIMARY_CTA}
                      data-track-attr-nltext={item.gaContext}
                    >
                      {item?.displayIcon ? (
                        <span className="cat-u-display-flex">
                          {item?.icon}
                          <span className="cat-u-padding-left-sm">
                            {t(item.label)}
                          </span>
                        </span>
                      ) : (
                        t(item.label)
                      )}
                    </CatListItem>
                  )
                );
              })}
            </CatList>
          </ContextualMenu>
        </Portal>
      )}
    </>
  );
};

export default ContextMenuActionLayout;
